import type { ArtworkType } from '@/@types/microcms-type'

export type TranslatableField = {
    fieldId: string
    [key: string]: string
}

type GetTranslatedFieldParams = {
    field: TranslatableField
    middle?: string
    locale?: string
}

export const getTranslatedField = ({
    field,
    middle,
    locale
}: GetTranslatedFieldParams) => {
    const fieldName = middle ? `${field.fieldId}_${middle}` : `${field.fieldId}`

    // Japanese is fallback
    return field[`${fieldName}_${locale}`] ?? field[`${fieldName}_ja`]
}

export const stripHtml = (html: string) => {
    const text = html?.replace(/(<([^>]+)>)/gi, '')
    return text
}

export const getDescription = ({
    meta,
    description,
    locale
}: {
    meta: ArtworkType['meta']
    description?: ArtworkType['description']
    locale?: string
}) => {
    if ((meta && meta.meta_ja) || (meta && meta.meta_en)) {
        // @ts-expect-error
        return getTranslatedField({ field: meta, locale })
    } else if (description) {
        const strippedText = stripHtml(
            getTranslatedField({ field: description, locale })
        )
        return strippedText?.substring(0, 150)
    }
    return null
}

export const getImage = ({
    meta,
    thumbnail_image
}: {
    meta: ArtworkType['meta']
    thumbnail_image: ArtworkType['thumbnail_image']
}) => {
    if (meta && meta.meta_image) {
        return {
            url: meta.meta_image.url,
            width: meta.meta_image.width,
            height: meta.meta_image.height
        }
    } else if (thumbnail_image && thumbnail_image.url) {
        return {
            url: thumbnail_image.url,
            width: thumbnail_image.width,
            height: thumbnail_image.height
        }
    }
    return undefined
}

export const getExtension = (url: string) => {
    const extension = url.split('.').pop()
    return extension === url ? '' : extension
}

export const fetcher = (url: string): Promise<any> =>
    fetch(url).then((res) => res.json())

export const isBrowser = typeof document !== 'undefined'

export const throttle = (func: Function, limit: number) => {
    let inThrottle: boolean
    return function (this: any) {
        const args = arguments
        const context = this
        if (!inThrottle) {
            func.apply(context, args)
            inThrottle = true
            setTimeout(() => (inThrottle = false), limit)
        }
    }
}
